
function renderPromoGraphics() {
  // Prevent double execution
  if (window.__promoRendered) return;
  window.__promoRendered = true;

  const promoDataEl = document.getElementById("promo-data");
  if (!promoDataEl) return;

  // product grid selection for all collections (new template)
  const grid = document.querySelector('.collection-grid, .category-products, #product-grid');
  const productCards = Array.from(grid?.querySelectorAll('.product-card') || []).filter(isVisible);
  if (productCards.length === 0) return;

  // Parse JSON data from hidden DOM element
  const promos = shuffleArray(JSON.parse(promoDataEl.getAttribute("data-promo-graphics")));
  const products = JSON.parse(promoDataEl.getAttribute("data-products"));


  const gridColumns = getGridColumns(); // 2 on mobile, 4 on desktop
  const layoutMap = buildLayoutMap(productCards, products); // Flattened layout map of valid products

  // Check if any promo is flagged with show_first = true
  let hasForcedPromo = false;
  const forcedIndex = promos.findIndex(p => p.show_first === true || p.show_first === "true");

  if (forcedIndex !== -1) {
    const forcedPromo = promos.splice(forcedIndex, 1)[0];
    forcedPromo.__forceFirst = true;
    promos.unshift(forcedPromo); // Move to top of list
    hasForcedPromo = true;
  }

  // Fallback behavior: if no promo is forced, and the first one is Small, treat it like a forced promo at unit 8
  if (!hasForcedPromo && promos.length > 0 && promos[0].size === 'Small') {
    promos[0].__forceFirst = true;
    promos[0].__fallbackFirstSmall = true;
  }

  // Layout state
  let layoutUnits = 1;
  let lastInsertedUnit = -8; // Ensure the first promo always has "1 row" of space
  let i = 0;

  while (i < layoutMap.length && promos.length > 0) {
    const current = layoutMap[i];
    if (current.type !== 'product') {
      i++;
      continue;
    }

    const promo = promos[0];
    const size = getPromoSizeUnits(promo.size); // Small = 1, Medium = 2, Large = 4
    const isLarge = size === 4;
    const isForced = promo.__forceFirst;
    const isFallbackFirstSmall = promo.__fallbackFirstSmall;
    let insertUnit = layoutUnits;

    const forcedUnitMap = { Small: 8, Medium: 7, Large: 5 };
    const forcedTargetUnit = forcedUnitMap[promo.size];

    // If the promo is forced to a specific unit (via show_first or fallback logic)
    if (isForced) {
      insertUnit = forcedTargetUnit;
      i = insertUnit - 1;

      if (layoutUnits < insertUnit) {
        layoutUnits++;
        continue;
      }

    // Otherwise, use randomized placement for Medium or Small
    } else if (!isLarge) {
      insertUnit = getRandomPositionInRow(layoutUnits, size, gridColumns);

      if (layoutUnits < insertUnit) {
        layoutUnits++;
        i++;
        continue;
      }

      i = insertUnit - 1;
    }

    // Determine whether the promo can be inserted at this location
    const canInsert = validateInsertion({
      insertUnit,
      promo,
      layoutMap,
      i,
      isForced,
      layoutUnits,
      lastInsertedUnit,
      gridColumns
    });

    if (canInsert) {
      // Insert the promo before the current product
      insertPromo(promo, layoutMap[i].element, size);
      layoutMap.splice(i, 0, ...Array(size).fill({ type: 'promo' }));

      lastInsertedUnit = insertUnit;
      layoutUnits = insertUnit + size;
      promos.shift();
      i += size;
    } else {
      layoutUnits++;
      i++;
    }
  }
}

// Helpers

// Checks if an element is visible in the DOM
// Used to avoid counting hidden product cards in layout
function isVisible(element) {
  return element.offsetParent !== null;
}

// Determines number of grid columns based on screen width
// 4 columns for desktop, 2 for mobile
function getGridColumns() {
  return window.innerWidth < 1200 ? 2 : 4;
}

// Used to display promo graphics in different positions each page load
function shuffleArray(array) {
  const shuffled = array.slice();
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

// Builds an ordered map of layout items (just product cards, not promos)
// This will be used to simulate layout unit positions
function buildLayoutMap(productCards, products) {
  return productCards.reduce((acc, card) => {
    const productId = card.getAttribute('data-id');
    const product = products.find(p => p.id == productId);

    // Filters out hidden, retired, combined, or offsite-only products
    const isVisibleProduct = product &&
      !product.type.includes('Combined') &&
      !product.tags.includes('retired') &&
      (!product.tags.includes('hide') || product.offsite_url !== '');
    if (isVisibleProduct) acc.push({ type: 'product', element: card });
    return acc;
  }, []);
}

// Converts a promo graphic size string into equivalent layout width units
// Small = 1 unit, Medium = 2 units, Large = 4 units
function getPromoSizeUnits(size) {
  if (size === 'Large') return 4;
  if (size === 'Medium') return 2;
  return 1;
}

// Returns a valid random insert position in the current layout row
// For Medium promos, ensures they never appear in the center columns (2 & 3)
function getRandomPositionInRow(currentUnit, size, columns) {
  const rowStart = currentUnit - ((currentUnit - 1) % columns);
  const maxOffset = Math.max(0, columns - size);

  let offsetOptions = [];

  for (let o = 0; o <= maxOffset; o++) {
    const col1 = o + 1;
    const col2 = col1 + size - 1;

    // Prevent Medium promos from occupying columns 2 & 3
    const isMiddleColumns = (col1 === 2 && col2 === 3);
    if (size === 2 && isMiddleColumns) continue;

    offsetOptions.push(o);
  }
  // Choose random offset from filtered valid options
  const offset = offsetOptions[Math.floor(Math.random() * offsetOptions.length)];
  return rowStart + offset;
}

// Validates if a promo can be inserted based on spacing, row alignment, and promo rules
function validateInsertion({ insertUnit, promo, layoutMap, i, isForced, layoutUnits, lastInsertedUnit, gridColumns }) {
  const size = getPromoSizeUnits(promo.size);
  const isLarge = size === 4;

  // Large promos must start at the beginning of a row
  const isCleanRowStart = (insertUnit - 1) % gridColumns === 0;

  // All promos must be at least 1 full row (8 units) apart from previous
  const isNotFirstRow = layoutUnits >= 5;
  const spacingOk = (insertUnit - lastInsertedUnit) >= 8;

  // Check if this unit matches forced position
  const forcedUnitMap = { Small: 8, Medium: 7, Large: 5 };
  const expectedUnit = forcedUnitMap[promo.size];
  const matchesForcedUnit = isForced && insertUnit === expectedUnit;

  return (
    (matchesForcedUnit || (!isForced && isNotFirstRow && spacingOk)) &&
    (!isLarge || isCleanRowStart) &&
    layoutMap[i] && layoutMap[i].type === 'product'
  );
}

// Creates the DOM element for the promo graphic and inserts it before the given product card
// Also adds the appropriate size-based class
function insertPromo(promo, beforeEl, size) {
  const promoDiv = document.createElement('div');
  promoDiv.classList.add('promo-graphic-card', promo.size.toLowerCase());
  
  const sizeMap = { 'Small': 'sm', 'Medium': 'md', 'Large': 'lg' };
  const sizeKey = sizeMap[promo.size] || promo.size.toLowerCase();
  const promoName = promo.name || 'promo';
  const gaEvent = `promo_graphic_${sizeKey}_${promoName}`;
  
  promoDiv.innerHTML = `
    <a href="${promo.link}"
      data-ga-event="${gaEvent}"
      data-ga-category="Promo Graphics"
      data-title="${promoName || promo.alt || 'Promo Graphic'}">
      <img src="${promo.image}" alt="${promo.alt || promoName || 'Promo Image'}" class="promo-image">
    </a>`;
  beforeEl.before(promoDiv);
}

/**
 * Tries to render promo graphics with progressive delay.
 * Ensures graphics are inserted once products and data are fully available.
 * Will retry up to 10 times with 200ms delay between attempts.
 */
function fallbackRender(attempt = 0) {
  if (window.__promoRendered) return;
  if (attempt > 10) return;

  const grid = document.querySelector('.collection-grid, .category-products, #product-grid');
  const hasCards = grid?.querySelectorAll('.product-card').length > 0;
  const hasPromoData = !!document.getElementById('promo-data');

  if (hasCards && hasPromoData) {
    renderPromoGraphics();
  } else {
    setTimeout(() => fallbackRender(attempt + 1), 200);
  }
}

/**
 * Watches the product grid for changes (e.g., slow-loading themes or dynamic product rendering).
 * Once it detects visible product cards and promo data, it triggers rendering and stops observing.
 */
function observeProductGrid() {
  const grid = document.querySelector('.category-products, .collection-grid, #product-grid');

  // Try again shortly if the grid isn't loaded yet
  if (!grid) return setTimeout(observeProductGrid, 50);

  const observer = new MutationObserver(() => {
    const cards = grid.querySelectorAll('.product-card');
    const promoReady = document.getElementById("promo-data");

    if (cards.length > 0 && promoReady) {
      observer.disconnect(); // Stop observing once ready
      renderPromoGraphics();
    }
  });

  observer.observe(grid, { childList: true, subtree: true });
  
  // Backup fallback in case MutationObserver doesn't catch the changes
  fallbackRender();
}

// Entry point - Start observing and loading promos
observeProductGrid();
